var createReactClass = require('create-react-class');
import React from 'react';
import { MultiSelect } from "react-multi-select-component";


const EditProfile = createReactClass({
  getInitialState: function() {
    var userProfile = this.props.userProfile;
    return {
      first_name: userProfile.first_name,
      middle_initial: userProfile.middle_initial,
      last_name: userProfile.last_name,
      specialty_id: userProfile.specialty_id,
      journal_id: userProfile.journal_id,
      sub_specialty_name: userProfile.sub_specialty_name,
      suffix: userProfile.suffix,
      user_qualifications: userProfile.user_qualifications || [],
      selectedJournalId: userProfile.journal_id,
      otherQualification: ''
    };
  },

  renderQualifications: function() {
    var qualificationGroups = [];
    var group = [];
    this.props.qualifications.forEach((qual, idx) => {
      if (idx > 0 && idx % 7 === 0) {
        qualificationGroups.push(group);
        group = [];
      }
  
      const isChecked = this.state.user_qualifications == qual;
      
      if (['Ph.D.', 'Bachelor', 'Master'].includes(qual)) {
        group.push((
          <div key={qual} className="large-4 columns left checks-column">
            <label htmlFor={qual}>
              <input
              value={qual}
              checked={isChecked}
              onChange={this.handleCheck}  // Handle selection change
              type="radio"
              id={qual}
              name="user_qualifications"  // Same name for all radio buttons to group them
              />
              {qual}
            </label>
          </div>
        ));
      } else {
        // Handle the "Other" option (radio button for custom input)
        group.push((
          <div key="other" className="large-4 columns left checks-column">
            <label htmlFor="other_qualification">
              <input
              type="radio"
              id="other_qualification"
              name="qualification"
              value="other"
              checked={!['Ph.D.', 'Bachelor', 'Master'].includes(this.state.user_qualifications)}
              onChange={this.handleOtherSelection}
              />
              Other
            </label>

            {/* Render the text input if "Other" is selected */}
            { !['Ph.D.', 'Bachelor', 'Master'].includes(this.state.user_qualifications) && (
              <input
                type="text"
                placeholder="Please specify..."
                value={this.state.user_qualifications}
                onChange={this.handleOtherInputChange}
                className="other-input"
              />
            )}
          </div>
        ));
      }
    });
  
    qualificationGroups.push(group);
    return qualificationGroups.map((group, idx) => (
      <div className="row" key={idx}>
        {group}
      </div>
    ));
  },
  
  handleOtherSelection: function(event) {
    const value = event.target.value;
    if (value === 'other') {
      this.setState({
        user_qualifications: '',
        otherQualification: ''  // Clear previous input if any
      });
    }
  },
  
  handleOtherInputChange: function(event) {
    this.setState({
      otherQualification: event.target.value,
      user_qualifications: event.target.value
    });
  },

  handleJournalChange: function(e) {
    const value = e.target.value;
    const selectedJournalId = value ? parseInt(value) : null;
    this.setState({ journal_id: selectedJournalId, selectedJournalId });
  },

  handleSpecialtyChange: function(selectedOptions) {
    if (selectedOptions.length <= 3) {
      this.setState({ specialty_id: selectedOptions || [] })
    } else {
      alert("You can select up to 3 specialties");
    }
  },

  renderSpecialtyOptions: function() {
    if (this.state.selectedJournalId === null) {
      return null;
    }

    const filteredSpecialties = this.props.specialties.filter(spec => spec.journal_id === this.state.selectedJournalId);

    return (
      <div>
        <MultiSelect
          options={filteredSpecialties || []}
          value={this.state.specialty_id || []}
          onChange={this.handleSpecialtyChange}
          labelledBy={"Select Specialty"}
          hasSelectAll={false}
        />
      </div>
    );
  },

  renderJournalsOptions: function() {
    return this.props.journals.map(journal => (
      <option key={journal[1]} value={journal[1]}>
        {journal[0]}
      </option>
    ));
  },

  handleChange: function(e) {
    this.setState({ [e.target.name]: e.target.value });
  },

  handleCheck: function(event) {
    const value = event.target.value;
    this.setState({
      user_qualifications: value
    });
  },

  hasValidSpecialty: function() {
    return this.state.specialty_id !== 'Select Specialty';
  },

  render: function() {
    return (
      <div className="reveal-modal medium" data-reveal id="edit-profile-modal" data-options={this.props.setUncloseable()}>
        <div className="modal-body">
          {this.props.renderFlash()}
          {this.props.renderModalCloseX()}
          <div className="modal-content">
            <h4>{this.props.confirmation ? "Welcome to Cureus Journal Series! Please review your profile for accuracy." : "Edit My Profile"}</h4>
            <br/>
            <div className="row">
              <div className="large-4 medium-4 columns">
                <label>First Name*</label>
                <input type="text" name="first_name" value={this.state.first_name} onChange={this.handleChange}></input>
              </div>
              <div className="large-1 medium-1 columns">
                <label>M.I.</label>
                <input size="1" maxLength="1" name="middle_initial" type="text" value={this.state.middle_initial} onChange={this.handleChange}></input>
              </div>
              <div className="large-5 medium-5 columns" style={{float:"left"}}>
                <label>Last Name*</label>
                <input type="text" name="last_name" value={this.state.last_name} onChange={this.handleChange}></input>
              </div>
            </div>
            <div className="qualifications checkbox-container">
              <h6 className="reg">Qualifications (Check all that apply)</h6>
              {this.renderQualifications()}
            </div>
            <div className="row">
              <div className="large-6 medium-6 columns">
                <label>Primary Journal*</label>
                <select defaultValue={this.state.journal_id} name="journal_id" onChange={this.handleJournalChange}>
                  <option value="">Select Journal</option>
                  {this.renderJournalsOptions()}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="large-6 medium-6 columns">
                <label>Specialties*</label>
                {this.renderSpecialtyOptions()}
              </div>
              <div className="large-6 medium-6 columns">
                <label>Subspecialty</label>
                <input type="text" value={this.state.sub_specialty_name || ""} name="sub_specialty_name" onChange={this.handleChange}></input>
              </div>
            </div>
            {this.props.renderErrors()}
            <div className='modal-footer'>
              {this.props.renderButton({user: this.state, section: 'EditProfileForm'}, this.props.updateProfilePath, () => this.forceUpdate(), this.hasValidSpecialty())}
            </div>
          </div>
        </div>
      </div>
    );
  }
});

export default EditProfile;
